<template lang='pug'>
    Erro(v-if='usuarioLogado && usuarioParceriaSustentavel')

    #app(v-else-if='usuarioLogado')
        menu-lateral(:botoes='botoes,', :key='atualizarBotoes')

        menu-superior(:route='this.$route.name', :routeParams='this.$route.params', @updateGrupoSelecionado='updateGrupoSelecionado')

        section.conteudo-central
            router-view

        ExportarDocumentoVue
        ExportarDocumentoAnaliseCredito
        ModalDocumentosAssincronos(
            @reloadLaudoRenovabio='reloadLaudoRenovabio'
        )

        Loading
</template>

<script>
import store from '@/store';
import { mapState } from 'vuex';

import MenuLateral from '@/components/layout/MenuLateral';
import MenuSuperior from '@/components/layout/MenuSuperior.vue';
import Loading from '@/components/Loading';
import ExportarDocumentoVue from '@/components/diagnosticoSocioambiental/ExportarDocumento';
import ExportarDocumentoAnaliseCredito from '@/components/preAnaliseCredito/ExportarDocumentoAnaliseCredito.vue';
import ModalDocumentosAssincronos from '@/components/laudos/renovabio/ModalDocumentosAssincronos.vue';
import Manutencao from '@/views/Manutencao.vue';
import authService from '@/services/AuthService';
import controleAcesso from '@/utils/controleAcesso';
import Temas from '@/utils/layouts/temas';
import Erro from '@/views/Erro.vue';

export default {
    name: 'app',
    components: {
        Erro,
        MenuSuperior,
        MenuLateral,
        Loading,
        ExportarDocumentoVue,
        ExportarDocumentoAnaliseCredito,
        ModalDocumentosAssincronos,
        Manutencao
    },
    data() {
        return {
            botoes: [],
            atualizarBotoes: 0
        };
    },
    async created() {
        await this.buscarDadosUsuarioLogado();
    },
    computed: {
        ...mapState(['usuarioLogado']),

        ano: function() {
            return new Date().getFullYear();
        },
        usuarioParceriaSustentavel: function() {
            return (
                this.usuarioLogado.attrGroupUser &&
                this.usuarioLogado.attrGroupUser.includes('BUNGE')
            );
        }
    },
    methods: {
        async buscarDadosUsuarioLogado() {
            await authService.buscarDadosUsuarioLogado()
                .then(({ data }) => {
                    authService.setSessionLocale();
                    Temas.aplicarTema(data.tema);

                    document.title = data.logoUrl ? 'Parceria Sustentável' : 'Lyra';
                    const link = document.querySelector('[rel=\'icon\']');
                    link.setAttribute('href', data.faviconUrl ? data.faviconUrl : '/lyra-favicon/favicon3.ico');

                    if (data.isLaudo) {
                        data.authorities = data.authorities.map(item => {
                            if (item.authority === 'ROLE_FEATURE_LAUDO') {
                                return item;
                            }
                        });
                        data.authorities = data.authorities.filter(item => item !== undefined);
                        data.preAnaliseCreditoAccess = false;
                        data.sentinelHubAccess = false;
                        data.monitoramentoSocioambientalAccess = false;
                        data.monitoramentoAgricolaAccess = false;
                        store.dispatch('setUsuarioIsLaudo', true);
                    }
                    controleAcesso.buscarPermissoesMenuFeature(data)
                    .then(resultado => {
                        if (data.isLaudo && data.isAdmin) {
                            resultado = resultado.filter(item => item.name === 'BotaoHome' || item.name === 'BotaoLaudos' || item.name === 'BotaoUsuarios');
                        } else if (data.isLaudo && !data.isAdmin) {
                            resultado = resultado.filter(item => item.name === 'BotaoHome' || item.name === 'BotaoLaudos');
                        }
                        this.atualizarBotoes += 1;
                        this.botoes = resultado;
                    });

                    if (data.isAnalyst) {
                        this.$router.push({ name: 'Laudos' });
                    }
                })
                .catch(_ => {
                    store.dispatch('setUsuarioLogado', null);
                    this.$router.push({ name: 'manutencao' });
                });
        },
        reloadLaudoRenovabio() {
            if (window.location.href.includes('renovabio')) {
                window.location.reload();
            }
        },
        updateGrupoSelecionado() {
            this.buscarDadosUsuarioLogado();
        }
    }
};
</script>

<style lang='scss'>
#app {
    height: 100vh;
    width: 100vw;
    overflow: hidden;

    .conteudo-central {
        height: calc(100vh - 65px);
        width: calc(100vw - 70px);
        margin-top: 65px;
        margin-left: 70px;
        overflow-y: auto;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        border-radius: 10px;
        background: var(--white);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--primary);
        border-radius: 10px;
        border: 1px solid var(--white);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b5b5b5;
    }

    @media (max-width: 1370px) {
        Footer#lyra-rodape {
            padding-top: 80px;
            margin: 0;

            p {
                width: 100%;
                text-align: center;
                margin-bottom: 0;
                margin-left: 70px;
            }
        }
    }
}
</style>
